/**
 * @deprecated
 * Duplicates TableType, should be removed
 * Needs ParentType fields to be updated in Attributes tables
 */
export enum CalibrationSetType {
    ZONE_COMBINATION,
    OVERLAY,
    TYPOLOGY,
    OVERLAY_TYPOLOGY,
}

export enum CalibrationSetCollectionName {
    CALIBRATION_ZONE_COMBINATION = 'zones',
    CALIBRATION_OVERLAY = 'overlays',
    CALIBRATION_TYPOLOGY = 'typologies',
    CALIBRATION_BONUS = 'bonus',
    BUILDING_TYPOLOGY = 'BuildingTypology',
    OVERLAY_TYPOLOGY = 'OverlayTypology'
}

export function getCalibrationSetTypeId(calibrationSetName: string) {
    switch (calibrationSetName) {
        case CalibrationSetCollectionName.CALIBRATION_OVERLAY:
            return CalibrationSetType.OVERLAY;
        case CalibrationSetCollectionName.CALIBRATION_ZONE_COMBINATION:
            return CalibrationSetType.ZONE_COMBINATION;
        case CalibrationSetCollectionName.CALIBRATION_TYPOLOGY:
            return CalibrationSetType.TYPOLOGY;
        case CalibrationSetCollectionName.OVERLAY_TYPOLOGY:
            return CalibrationSetType.OVERLAY_TYPOLOGY;
    };
}

export function getCalibrationObjectTypeStr(value: number): string {
    return [
        'Zone',
        'Overlay',
        'Typology',
    ][value];
}
